import Vue from 'vue';
import VueTippy, { TippyComponent } from "vue-tippy";
import Wrapper from './Wrapper.vue';
import store from './store';
import CustomWindow from './CustomWindow';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

Vue.config.productionTip = false;

Vue.use(VueTippy);

// register components
Vue.component('Login', () => import(/* webpackChunkName: "login" */ './components/Login.vue'));
Vue.component('GoalExperienceDetails', () => import(/* webpackChunkName: "goalExperienceDetails" */ './components/GoalExperienceDetails.vue'));
Vue.component('NedNavigator', () => import(/* webpackChunkName: "nedNavigator" */ './components/NedNavigator.vue'));
Vue.component('NedNavigatorToggle', () => import(/* webpackChunkName: "nedNavigatorToggle" */ './components/NedNavigatorToggle.vue'));

Vue.component("tippy", TippyComponent);

declare const window: CustomWindow;
window.vuexStore = store;

//#region ios fixes

// ios top bar fix
// https://dev.to/maciejtrzcinski/100vh-problem-with-ios-safari-3ge9
const appHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}
window.addEventListener('resize', appHeight);
appHeight();

// ios detect
// https://stackoverflow.com/questions/9038625/detect-if-device-is-ios
function iOS(): boolean {
    return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

//#endregion ios fixes

// init vue components inside hybrid application
const Constructor = Vue.extend(Wrapper);
document.addEventListener('DOMContentLoaded', () => {
    if (iOS()) {
        document.body.classList.add("ios");
    }

    document.querySelectorAll('[data-vue-component]').forEach((el) => {
        const instance = new Constructor({
            store: store,
            propsData: {
                componentName: el.getAttribute('data-vue-component'),
                componentParams: { params: el.getAttribute('data-vue-params') }
            }
        });

        instance.$mount();

        el.replaceWith(instance.$el);
    });
    
    // load goal, etc
    store.dispatch('init');
});